module.exports = __webpack_public_path__ + "static/media/lw.f875c466.png";